import React, { useState } from 'react';

import {
  OuterContainer,
  ContainerHeading,
  RecruitmentStagesContainer,
  FlexContainer,
  LabelAndCheckboxContainer,
  TextInput,
  ErrorMessage,
} from './styles';
import { Button } from '../../components';

export default React.memo(({ recruitmentStages, updateStages, id, isSuperadmin }) => {
  const [stages, setStages] = useState(recruitmentStages || []);
  const [formError, setFormError] = useState('');

  const editStage = (name, index) => {
    let stagesCopy = [...stages];
    stagesCopy[index] = name.trim();
    setStages(stagesCopy);
  };

  const removeStage = (index) => {
    let stagesCopy = [...stages];
    stagesCopy.splice(index, 1);
    setStages(stagesCopy);
  };

  const addStage = () => {
    let stagesCopy = [...stages];
    stagesCopy.push('');
    setStages(stagesCopy);
  };

  const updateStage = () => {
    if (stages.includes('')) return setFormError('Stages name cannot be empty');
    else setFormError('');
    if (isSuperadmin) updateStages(id, { value: stages });
    else updateStages(id, { stages });
  };

  const renderStages = () => {
    return stages.map((stage, index) => {
      return (
        <LabelAndCheckboxContainer key={index}>
          <TextInput
            type="text"
            isEditing={true}
            padding="5px 5px 0 5px"
            height="30px"
            margin={index + 1 === stages.length && formError ? '8px 0 15px 0' : '8px 0 0 0'}
            width="50%"
            fullWidthOnMobile={true}
            onChange={(e) => editStage(e.target.value, index)}
            value={stage}
          />
          <Button small primaryRed padding="5px 9px 5px 10px" margin="6px 0 0 6px" onClick={() => removeStage(index)}>
            <i className="fa fa-times" aria-hidden="true"></i>
          </Button>
        </LabelAndCheckboxContainer>
      );
    });
  };
  return (
    <OuterContainer>
      <ContainerHeading>Recruitment Stages</ContainerHeading>
      <RecruitmentStagesContainer>
        {renderStages()}
        {formError && <ErrorMessage>{formError}</ErrorMessage>}
        <FlexContainer>
          <Button
            small
            primaryBlue
            primaryGreenBorder
            removeMargin
            margin={formError ? '0' : '20px 0 0 0px'}
            onClick={() => addStage()}
          >
            Add
          </Button>
          <Button
            small
            primaryBlue
            primaryGreenBorder
            removeMargin
            margin={formError ? '0 0 0 10px' : '20px 0 0 10px'}
            onClick={() => updateStage()}
          >
            Save
          </Button>
        </FlexContainer>
      </RecruitmentStagesContainer>
    </OuterContainer>
  );
});
